export async function openFileWithHandle(type: FilePickerAcceptType) {
  if ("showOpenFilePicker" in window) {
    const [picker] = await showOpenFilePicker({
      multiple: false,
      types: [type],
    })
    await picker.requestPermission({ mode: "read" })
    return picker.getFile()
  }

  return openFile()
}

export async function openFile(accept = ".har,.json") {
  const input = document.createElement("input")
  input.type = "file"
  input.accept = accept

  return new Promise<File>((resolve, reject) => {
    input.onchange = () => {
      const file = input.files?.[0]
      if (!file) return
      resolve(file)
    }
    input.onerror = reject
    input.click()
  })
}
